import {createContext, ReactElement, useEffect, useState} from "react";
import {FirebaseContext as Context} from "./FirebaseContext";
import {useDispatch} from "react-redux";

interface IProps {
    children: ReactElement
    user: string
}
const FirebaseContext = createContext<Context>(undefined!);
export default function FirebaseProvider({children, user}: IProps) {
    const dispatch = useDispatch();
    const [provider, setProvider] = useState<Context>(new Context(dispatch, user));

    useEffect(() => {
        setProvider(new Context(dispatch, user));
    }, [dispatch, user]);
    return <FirebaseContext.Provider value={provider}>{children}</FirebaseContext.Provider>;
};
export {FirebaseContext};
